// angular
//   .module("HeroPRO")
//   .controller("OptionsPopupController",

/* @ngInject */
export default function OptionsPopupController($scope, $anchorScroll, $rootScope, $location, raSpinnerService, productFilterService, optionsPopupService) {
    const vm = this;

    vm.alphabet = ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z'];

    let alphabeticalOptions = [];
    vm.letterGroupedOptions = angular.copy(optionsPopupService.letterGroupedOptions());
	    vm.currentFilter = angular.copy(optionsPopupService.getPopupData().currentFilter);

    // Check if letter exists
    vm.checkLetter = function (letter) {
        for (let i = 0; i < vm.letterGroupedOptions.length; i++) {
            if (letter === vm.letterGroupedOptions[i].letterHead) {
                return true;
            }
        }
        return false;
    };


    // Scroll to corresponding letter
    vm.scrollToLetter = function (letter) {
        $anchorScroll(letter);
    };

    // Clear out alphabeticalOptions and remove alphabet grouping, save chekced options
    function rebuildOptionsObject() {
        const obj = vm.letterGroupedOptions;
        alphabeticalOptions = [];
        for (let i = 0; i < obj.length; i++) {
            for (let j = 0; j < obj[i].letterOptions.length; j++) {
                const option = obj[i].letterOptions[j];
                alphabeticalOptions.push({
                    DisplayName: option.DisplayName,
                    optionID: option.optionID,
                    isChecked: option.isChecked,
                });
            }
        }
    }

    // Group of options to show in the sidebar
    function putSelectedOptionsInFront() {
        const options = alphabeticalOptions;
        const selectedOptions = [];
        const unselectedOptions = [];
        if (options) { // prevent function running before data is loaded
            // seperate selected options
            for (let i = 0; i < options.length; i++) {
                if (options[i].isChecked) {
                    selectedOptions.push(options[i]);
                } else {
            	unselectedOptions.push(options[i]);
                }
            }

            // if there are any selected options, swap it out with new sidebarOptions
            if (selectedOptions.length > 0) {
                alphabeticalOptions = selectedOptions.concat(unselectedOptions);
            } else {

            }
        }
    }

    // Apply selected options back into main DTO
    function updateMainDTO() {
        const filter = vm.currentFilter;
        for (let i = 0; i < productFilterService.productTypeFilters.length; i++) {
            // Find matching options object
            if (productFilterService.productTypeFilters[i].Deprecated_ProductAttributeNameId === filter.Deprecated_ProductAttributeNameId) {
                // Copy object back into main DTO
                productFilterService.productTypeFilters[i].InputOptions = alphabeticalOptions;
            }
        }
    }

    // Apply selected options back vm.currentFilter
    function updateCurrentFilter() {
    // Copy object back into main DTO
        vm.currentFilter.InputOptions = alphabeticalOptions;
    }

    // So we know when the popup is loaded
    $rootScope.$broadcast('optionsPopupController.popupShown');


    // Apply options modal
    vm.applyOptions = function () {
		    rebuildOptionsObject();
		    putSelectedOptionsInFront();
		    updateMainDTO();
		    updateCurrentFilter();
			  $rootScope.$broadcast('optionsPopupController.applyOptions', vm.currentFilter);
    };

    vm.cancelOptions = function () {
        vm.showAttributes = false;
    };
}




// WEBPACK FOOTER //
// ./src/app/productCenter/pages/productsearch/optionsPopup/optionsPopupController.js